// extracted by mini-css-extract-plugin
export var standaloneTable = "_dv-0";
export var standaloneTableWithBodyFill = "_dv-1";
export var withExtraHeader = "_dv-2";